import { FormBuilder } from '@angular/forms';

export interface OrgAnonymousLinksSharingPolicySchema {
    type: 'object';
    properties: {
        SharingCapability: { type: 'number'; const: number };
        OneDriveSharingCapability: { type: 'number'; const: number };
        DefaultSharingLinkType: { type: 'number'; const: number };
        DefaultLinkPermission: { type: 'number'; const: number };
        FolderAnonymousLinkType?: { type: 'number'; const: number };
        FileAnonymousLinkType?: { type: 'number'; const: number };
        DisplayNamesOfFileViewersInSpo: { type: 'boolean'; const: boolean };
        DisplayNamesOfFileViewers: { type: 'boolean'; const: boolean };
    };
}

export function initOrgAnonymousLinksSharingPolicyForm(schema: OrgAnonymousLinksSharingPolicySchema) {
    const fb = new FormBuilder();

    return fb.group({
        SharingCapability: [schema.properties.SharingCapability.const],
        OneDriveSharingCapability: [schema.properties.OneDriveSharingCapability.const],
        DefaultSharingLinkType: [schema.properties.DefaultSharingLinkType.const],
        DefaultLinkPermission: [schema.properties.DefaultLinkPermission.const],
        DisplayNamesOfFileViewersInSpo: [schema.properties.DisplayNamesOfFileViewersInSpo.const],
        DisplayNamesOfFileViewers: [schema.properties.DisplayNamesOfFileViewers.const],
        FolderAnonymousLinkType: [schema.properties.FolderAnonymousLinkType?.const],
        FileAnonymousLinkType: [schema.properties.FileAnonymousLinkType?.const],
    });
}

export function generateOrgAnonymousLinksSharingPolicySchema(form): OrgAnonymousLinksSharingPolicySchema {
    const schema: OrgAnonymousLinksSharingPolicySchema = {
        type: 'object',
        properties: {
            SharingCapability: { type: 'number', const: +form.SharingCapability },
            OneDriveSharingCapability: { type: 'number', const: +form.OneDriveSharingCapability },
            DefaultSharingLinkType: { type: 'number', const: +form.DefaultSharingLinkType },
            DefaultLinkPermission: { type: 'number', const: +form.DefaultLinkPermission },
            DisplayNamesOfFileViewersInSpo: { type: 'boolean', const: form.DisplayNamesOfFileViewersInSpo },
            DisplayNamesOfFileViewers: { type: 'boolean', const: form.DisplayNamesOfFileViewers },
        },
    };

    if (+form.SharingCapability == 2) {
        schema.properties.FolderAnonymousLinkType = { type: 'number', const: +form.FolderAnonymousLinkType };
        schema.properties.FileAnonymousLinkType = { type: 'number', const: +form.FileAnonymousLinkType };
    }

    return schema;
}

export const oneDriveSharingCapabilityMapping = {
    0: 'Only people in your organization',
    1: 'New and existing guests',
    2: 'Anyone',
    3: 'Existing guests',
};

export const defaultSharingLinkTypeMapping = {
    1: 'Specific people (only the people the user specifies)',
    2: 'Only people in your organization',
    3: 'Anyone with the link',
};

export const SharingCapabilityMapping = {
    0: 'Only people in your organization',
    1: 'New and existing guests',
    2: 'Anyone',
    3: 'Existing guests',
};
